import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { LabeledCheckbox } from '@nextiva/next-ui';
import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';
import propTypeBlockStyling from 'styling/config/editorBlock/PropTypes/blockStyling';
import MatrixCheckableInputGroup from '../MatrixCheckableInputGroup/MatrixCheckableInputGroup';

export default class MatrixMultiGroupField extends Component {
  static propTypes = {
    option: optionPropTypes,
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    meta: PropTypes.object.isRequired,
    labelList: PropTypes.array,
    form: PropTypes.string.isRequired,
    styling: propTypeBlockStyling,
  };

  handleAnswer = label => checked => {
    const {
      option,
      input: { value, onChange },
    } = this.props;

    const checkedItem = {
      [label.id]: {
        option: option.value,
        selectedValue: label.value,
      },
    };
    const finalAnswer = checked
      ? { ...value, ...checkedItem }
      : omit(value, label.id);
    onChange(finalAnswer);
  };

  render() {
    const {
      input: { value },
      meta,
      option,
      labelList,
      form,
      styling,
    } = this.props;

    return (
      <MatrixCheckableInputGroup
        handleChange={this.handleAnswer}
        inputCellRenderer={LabeledCheckbox}
        option={option}
        labelList={labelList}
        value={value}
        meta={meta}
        form={form}
        styling={styling}
      />
    );
  }
}
